import * as React from 'react'
import * as PropTypes from 'prop-types'

import { Flex, IFlexProps } from '../flex'
import { css, Rule } from 'glamor'

interface ITouchableProps {
  onClick: (event: React.SyntheticEvent) => void
  onKeyPress?: (event: React.SyntheticEvent) => void
  disabled?: boolean
  role?: string
  tabIndex?: number
  style?: Rule
  component?: string | React.ComponentType<{}>
}

export class Touchable extends React.Component<
  ITouchableProps & Pick<IFlexProps, Exclude<keyof IFlexProps, 'onClick'>>
> {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func,
    role: PropTypes.string,
    tabIndex: PropTypes.number,
    component: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  }

  static defaultProps = {}

  handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      this.props.onClick(e)
    }
  }

  render() {
    const { component: Component = Flex, role = 'button', tabIndex = 0, style, ...props } = this.props

    const interactiveProps =
      props.onClick && !props.disabled
        ? {
            role,
            tabIndex,
            onKeyPress: this.props.onKeyPress || this.handleKeyPress,
            ...css(
              {
                cursor: 'pointer',
                '.intent-mouse &:focus': {
                  outline: 'none',
                },
              },
              style
            ),
          }
        : {
            ...css(style),
          }

    return <Component {...interactiveProps} {...props} />
  }
}
